  (function () {
    /* This script renders ABOVE the native buy-buttons form in the DOM, so it
       must wait for DOM-ready before resolving the form node. */
    function hrsbInit() {
    var root = document.getElementById('hrsb-' + HRSB_CFG.sectionId);
    if (!root || root.dataset.hrInit) return;
    root.dataset.hrInit = '1';

    var formId = root.dataset.formId;
    var plan8 = root.dataset.planSub8 || '';
    var form = document.getElementById(formId);
    var bar = document.getElementById('hrsb-bar-' + HRSB_CFG.sectionId);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Fixed-position elements must not live under transformed ancestors */
    if (bar && bar.parentNode !== document.body) document.body.appendChild(bar);

    /* selling_plan input lives INSIDE the product form (added in buy-buttons.liquid;
       created here as a fallback). It is enabled only for a resolved subscription
       allocation; the subscription controls are blocked if no valid plan exists. */
    var spInput = form ? form.querySelector('input[name="selling_plan"]') : null;
    if (form && !spInput) {
      spInput = document.createElement('input');
      spInput.type = 'hidden';
      spInput.name = 'selling_plan';
      spInput.value = '';
      spInput.disabled = true;
      form.appendChild(spInput);
    }

    var state = 'sub8'; /* 'sub8' (60-Day Subscription, default) | 'sub8once' (60-Day one-time) | 'sub4' (30-Day, sold out) */
    /* Keep the charge the customer will actually see as the primary price.
       2026-09-14: sub8 posts the SUBSCRIPTION variant (data-variant-sub8) and
       sub8once posts the PUBLIC one-time variant (data-variant-sub8once).
       While no hidden subscription variant exists Liquid emits the same id in
       both attributes, so behaviour is unchanged; only the selling_plan input
       differs (set for sub8, empty for sub8once). */
    var LABELS = {
      sub8: { atc: 'Add to Cart', bar: HRSB_CFG.sub8Bar, plan: plan8, variant: root.dataset.variantSub8 || '' },
      sub8once: { atc: 'Add to Cart', bar: HRSB_CFG.sub8OnceBar, plan: '', variant: root.dataset.variantSub8once || root.dataset.variantSub8 || '' },
      sub4: { atc: 'Add to Cart', bar: HRSB_CFG.sub4Bar, plan: '', variant: root.dataset.variantSub4 || '' }
    };
    /* Hidden variant-id input inside the native form — card selection swaps it
       between the 60-day and 30-day variants. */
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atcBtn = root.querySelector('[data-hrsb-atc]');
    var atcLabel = root.querySelector('[data-hrsb-atc-label]');
    var planError = root.querySelector('[data-hrsb-plan-error]');
    var barAtc = bar ? bar.querySelector('[data-hrsb-bar-atc]') : null;
    var barSegs = bar ? bar.querySelectorAll('[data-hrsb-bar-seg]') : [];
    var barSegWrap = bar ? bar.querySelector('.hrsb-bar__seg') : null;
    var barPrice = bar ? bar.querySelector('[data-hrsb-bar-price]') : null;
    var cards = root.querySelectorAll('[data-hrsb-card]');
    var soldOut = atcBtn ? atcBtn.disabled : false;

    /* Card body expand/collapse via grid-template-rows 0fr<->1fr. The CSS
       transition carries the motion and retargets smoothly if the user re-taps
       mid-animation, with no JS height measurement (which reflows off-GPU). */
    function setBody(card, open, instant) {
      var wrap = card.querySelector('[data-hrsb-body]');
      if (!wrap) return;
      if (wrap.dataset.open === String(open)) return;
      wrap.dataset.open = String(open);
      var rows = open ? '1fr' : '0fr';
      if (instant || reduceMotion) {
        /* snap without animating: suppress the transition for this one change */
        wrap.style.transition = 'none';
        wrap.style.gridTemplateRows = rows;
        wrap.getBoundingClientRect(); /* flush so a later change animates from here */
        wrap.style.transition = '';
        return;
      }
      wrap.style.gridTemplateRows = rows;
    }

    function applyState(instant) {
      var planId = LABELS[state].plan;
      var variantId = LABELS[state].variant;
      /* Only the subscription card (sub8) ever needs a selling plan. sub8once
         and sub4 always carry plan: '' by design, so this only fires on a
         genuine resolution failure (no 8-week plan found on the 60-Day variant). */
      var subscriptionUnavailable = state === 'sub8' && !planId;
      if (spInput) {
        if (planId) {
          spInput.value = planId;
          spInput.disabled = false;
        } else {
          spInput.value = '';
          spInput.disabled = true;
        }
      }
      if (idInput && variantId) {
        idInput.value = variantId;
        idInput.setAttribute('data-selected-id', variantId);
      }
      if (atcBtn) atcBtn.disabled = soldOut || subscriptionUnavailable;
      if (barAtc) barAtc.disabled = soldOut || subscriptionUnavailable;
      if (atcLabel && !soldOut && root.dataset.hrBusy !== '1') {
        atcLabel.textContent = subscriptionUnavailable ? 'Subscription Unavailable' : LABELS[state].atc;
      }
      if (planError) planError.hidden = !subscriptionUnavailable;
      /* Do not clobber the sticky bar's in-cart summary. When the bar is in
        its "in cart" state (something has been added), its price slot shows the cart
        summary, not the per-plan price, so a later card/seg reselection must not overwrite
        it. See the hrsbCartState sync below. */
      if (barPrice && !(bar && bar.classList.contains('is-incart'))) barPrice.textContent = LABELS[state].bar;
      if (barSegs && barSegs.length) {
        Array.prototype.forEach.call(barSegs, function (seg) {
          var on = seg.dataset.hrsbBarSeg === state;
          seg.classList.toggle('is-active', on);
          seg.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      /* Slide the segmented-toggle thumb to the active plan (CSS transitions it). */
      if (barSegWrap) barSegWrap.setAttribute('data-active', state);
      cards.forEach(function (c) {
        var on = c.dataset.hrsbCard === state;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        var input = c.querySelector('.hrsb-card__input');
        if (input) input.checked = on;
        setBody(c, on, instant);
      });

      /* Broadcast every selection change so OTHER sticky/ATC surfaces on the
         page (e.g. new-atc.liquid's Dawn sticky bar, when it renders instead
         of / alongside this one) can mirror the buy box instead of drifting
         to a stale default. This is the buy box's own state, so it is always
         the source of truth wherever both exist on the same page. */
      try {
        document.dispatchEvent(new CustomEvent('hrsb:state-change', {
          detail: {
            state: state,
            variantId: variantId,
            planId: planId,
            subscriptionUnavailable: subscriptionUnavailable,
            soldOut: soldOut
          }
        }));
      } catch (e) {}
    }

    function submitNative() {
      if (!form) return;
      var btn = form.querySelector('button[name="add"]');
      if (btn && !btn.disabled) {
        btn.click();
      } else if (!btn && form.requestSubmit) {
        form.requestSubmit();
      }
    }

    /* Busy state: swap the button label to "Adding…" while the add-request is in
       flight; returns a restore fn used only on the (rare) error fallback. */
    function setBusy(btn) {
      if (!btn) return null;
      var label = btn.querySelector('[data-hrsb-atc-label], .hrsb-bar__atc-lead');
      var prev = label ? label.textContent : null;
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Adding…';
      return function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        if (label && prev != null) label.textContent = prev;
      };
    }

    /* ===== Instant Add-to-Cart feedback (2026-08-09) =====
       MEASURED ON LIVE, iPhone profile, real tap: the button never changed at
       all after being tapped, and the cart drawer took 2,356 ms to appear.
       For nearly two and a half seconds the page looked completely unchanged,
       so people tapped again. And again. The Observer shows 121 sessions
       tapping Add to Cart 2+ times, one session 32 times, 988 dead clicks on
       this page, and shoppers reaching for "Decrease quantity" before leaving
       because the repeat taps had stacked up units they never wanted.

       setBusy() above already existed and was NEVER CALLED from anywhere.
       The fix was written and left unwired. This connects it, and adds the
       re-entry guard that stops a second tap from posting a second line item
       while the first request is still in flight (.is-busy already carries
       `pointer-events: none`, so the guard and the styling agree).

       Feedback is applied SYNCHRONOUSLY on the click, before applyState() or
       any network work, so the first frame after the tap already shows it. */
    /* Static, honest strings for the drawer's optimistic placeholder row (see
       assets/cart-drawer.js showOptimisticAdd()). This is a single-SKU store
       (HR-CANONICAL-FACTS: one product, sea buckthorn puree), so the product
       name is safe to state directly; only the SUPPLY/PLAN meta line varies
       by which card is selected. Never includes a price -- that stays a
       shimmer until the server's own numbers land. */
    function hrsbOptimisticDetails() {
      var metaByState = {
        sub8: 'Two Month Supply, Subscription',
        sub8once: 'Two Month Supply, One-Time',
        sub4: 'One Month Supply, One-Time'
      };
      var imgEl = document.querySelector('.hr-ecp__media img');
      return {
        title: 'Sea Buckthorn Purée',
        meta: metaByState[state] || '',
        imgSrc: imgEl ? (imgEl.currentSrc || imgEl.src) : '',
        imgAlt: imgEl ? imgEl.alt : ''
      };
    }

    var hrsbAddInFlight = false;
    function runAddToCart(btn) {
      if (hrsbAddInFlight) return;
      hrsbAddInFlight = true;
      var restore = setBusy(btn);

      /* ===== Instant optimistic drawer open (2026-08-27, LIVE REVENUE BUG) =====
         MEASURED on the dev theme under a throttled mobile connection: the
         drawer painted nothing at all -- first paint and "content ready" were
         the same timestamp -- for 1.5 to 3.4+ seconds after this tap, because
         everything waited on the /cart/add response. Opening the drawer here,
         synchronously, before any network request for this add is even sent,
         means the shopper sees their product and a (momentarily disabled)
         checkout button within the same frame as the tap. renderContents()
         (assets/cart-drawer.js), called once the real response lands, always
         clears this and paints the authoritative content over it -- nothing
         here is ever left standing once the truth arrives. */
      try {
        var hrsbDrawerEl = document.querySelector('cart-drawer');
        if (hrsbDrawerEl && typeof hrsbDrawerEl.showOptimisticAdd === 'function') {
          hrsbDrawerEl.showOptimisticAdd(hrsbOptimisticDetails());
        }
      } catch (e) {}

      var drawerEl = document.querySelector('cart-drawer, #CartDrawer');
      var obs = null;
      var timer = null;
      var fallbackTimer = null;
      var drawerOpened = false;
      function release() {
        if (!hrsbAddInFlight) return;
        hrsbAddInFlight = false;
        if (obs) obs.disconnect();
        if (timer) clearTimeout(timer);
        if (fallbackTimer) clearTimeout(fallbackTimer);
        if (restore) restore();
      }

      /* ===== Guaranteed route to checkout (2026-08-09) =====
         MEASURED: of 361 sessions that added to cart in 30 days, only 133 ever
         saw the cart drawer open. 228 people, 63 percent, added to cart and no
         cart ever appeared. 44 of them exited while still standing on this
         page; only 4 ever reached /cart. They were never given a way forward.

         The plumbing is NOT broken: there is one product-form, correctly bound
         to CART-DRAWER, with renderContents present, and it does open. The
         problem is TIME. Dawn posts the add, then fetches section renders,
         then opens the drawer: 2,356 ms measured on a fast wired connection.
         On real mobile data that is far longer, and shoppers leave or re-tap
         before it arrives.

         So the drawer is no longer the only route. If it has not opened in
         time, we confirm the item genuinely landed in the cart and send the
         shopper to /cart, which always renders and always has a Checkout
         button. A slightly less elegant page beats a shopper stranded on an
         unchanged product page with money in hand. */
      fallbackTimer = setTimeout(function () {
        if (drawerOpened) return;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (drawerOpened) return;              /* it opened while we asked */
            if (!c || !c.item_count) { release(); return; }  /* add genuinely failed */
            /* CORRECTED 2026-08-09: this used to navigate to /cart. That was
               wrong on THIS theme, because snippets/hr-checkout-gate.liquid
               deliberately "kills the /cart page" and bounces anyone who lands
               there back to this product page with ?hropencart=1. Sending a
               stranded shopper to /cart therefore handed them straight back to
               the gate that was already failing them. Open the drawer here
               instead: it is the same destination the gate was trying to reach,
               without the round trip. */
            var d = document.querySelector('cart-drawer');
            if (d && typeof d.open === 'function') { drawerOpened = true; d.open(); release(); }
            else { window.location.href = '/cart'; }   /* no drawer at all: /cart is still better than nothing */
          })
          .catch(function () { release(); });
      }, 2800);
      /* Release as soon as the drawer actually opens: that is the moment the
         shopper gets real feedback, so the button can stop claiming to be busy. */
      /* AUDIT FIX 2026-08-27: the class lands EARLY. Measured on the dev theme, the
         busy state cleared after ~180ms while the drawer did not become visible for
         ~3.4 to 3.9 seconds, so for over three seconds the button looked idle and the
         page looked unchanged - which is precisely the condition that makes people tap
         again (121 sessions tapped twice, one tapped 32 times, per the 2026-08-09 note
         above). Releasing on the class is releasing on a promise, not on the thing the
         shopper can actually see.
         Now we wait until the drawer has real painted geometry, which is the first
         moment there is genuine feedback on screen. requestAnimationFrame lets the
         browser finish laying it out before we measure. */
      if (drawerEl && window.MutationObserver) {
        var confirmVisible = function () {
          if (!hrsbAddInFlight) return;
          var r = drawerEl.getBoundingClientRect();
          var cs = window.getComputedStyle(drawerEl);
          var painted = r.height > 40 && r.width > 40 &&
                        cs.visibility !== 'hidden' && cs.display !== 'none' &&
                        parseFloat(cs.opacity || '1') > 0.1;
          if (painted) { drawerOpened = true; release(); return; }
          requestAnimationFrame(confirmVisible);
        };
        obs = new MutationObserver(function () {
          if (drawerEl.classList.contains('active') || drawerEl.classList.contains('is-open')) {
            requestAnimationFrame(confirmVisible);
          }
        });
        obs.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
      }
      /* Safety net: never leave the button stuck if the drawer never opens
         (JS error, offline, slow network). A permanently dead button would be
         worse than the bug being fixed. */
      timer = setTimeout(release, 8000);

      applyState(true);
      addToCart();
    }

    /* Add to Cart uses the selected 8-week selling plan for the 60-Day supply,
       or no plan for the 30-Day one-time supply. The native product form then
       updates and opens the cart drawer. */
    function addToCart() {
      /* The native product form owns Shopify's drawer update. applyState() has
         already set the correct id and selling_plan inputs before this runs. */
      if (state === 'sub8' && !LABELS.sub8.plan) {
        if (planError) planError.hidden = false;
        return;
      }
      addOrSetQuantityOne();
    }

    /* ===== Idempotent Add-to-Cart (2026-08-24, LIVE REVENUE BUG) =====
       MEASURED: session_mt7g2xw518f7bqz10bq3mb19t8y4g (mobile, India) tapped
       Add to Cart 4 times across ~75 seconds while going back and forth to
       checkout, ended up with "Cart 22 items", reached for Decrease quantity,
       and left with no order. Reproduced on live 154134183990: 4 taps,
       ~1.4s apart, produced 1 -> 1 -> 2 -> 2 items — Shopify's native
       /cart/add.js always INCREMENTS the existing line's quantity, so any
       repeat tap (unsure if the first one worked, going back from checkout to
       re-add, anything) silently stacks units nobody asked for. This is a
       single-SKU, 60-day-supply store: nobody means to buy more than one box
       by tapping the same button again.

       FIX (chosen over a hard cap or an "already in cart" button-swap):
       make a repeat tap on the SAME variant + selling plan idempotent. If the
       cart already holds a line for exactly what the buy box has selected,
       a second Add to Cart tap SETS that line's quantity to 1 via
       /cart/change.js instead of adding another unit. This was picked over
       (b) a numeric cap because a cap still lets 2-6 accumulate from repeat
       taps nobody intended, and over (c) an "in cart, view cart" button swap
       because that hides the control the shopper is looking at without
       actually fixing what a tap on it does, and needs the customer to
       still find their way to a quantity stepper. Genuine multi-box orders
       remain possible from the cart drawer's own quantity control, which is
       untouched by this. If the request fails for any reason, fall back to
       the native form submit rather than silently doing nothing. */
    /* PERF (owner brief 2026-08-27, LIVE REVENUE BUG, measured on the dev
       theme under a throttled mobile connection): this function's own
       idempotency preflight -- a GET /cart.js that must resolve BEFORE the
       real /cart/add is even sent -- was found sitting directly in front of
       the add on EVERY tap, adding a full serial network round trip (~0.5 to
       2+ seconds under real mobile latency and request contention with the
       page's own analytics beacons) to the single most common case: the
       FIRST add of a session, to a cart that is genuinely empty.

       The header's own cart-count bubble (sections/header.liquid) already
       states, server-rendered, whether the cart holds anything -- it is
       present in the DOM only `{%- if cart != empty -%}` and is kept correct
       by every renderContents()/hrRender() call this theme already makes.
       Reading it costs nothing. When it says the cart is empty, there is
       nothing for the idempotency check to find anyway (an empty cart has no
       existing line to collide with), so skip straight to the real add.

       SAFE BY CONSTRUCTION: the only failure mode is a STALE "empty" reading
       (another tab/device added something since this page last painted). In
       that case skipping the preflight produces exactly what this function
       already did whenever no matching line was found -- submitNative() --
       so the worst case is identical to today's existing behaviour, never
       worse. Any cart the bubble shows as non-empty keeps the FULL, unchanged
       preflight + idempotent-quantity path below. */
    function hrsbCartKnownEmpty() {
      return !document.querySelector('#cart-icon-bubble .cart-count-bubble');
    }

    function addOrSetQuantityOne() {
      var variantId = idInput ? idInput.value : LABELS[state].variant;
      var planId = spInput && !spInput.disabled && spInput.value ? spInput.value : null;
      if (!variantId) { submitNative(); return; }
      if (hrsbCartKnownEmpty()) { submitNative(); return; }
      fetch(HRSB_CART_URL + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          var existing = null;
          if (c && Array.isArray(c.items)) {
            existing = c.items.filter(function (it) {
              if (String(it.variant_id) !== String(variantId)) return false;
              var linePlanId = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
                ? String(it.selling_plan_allocation.selling_plan.id) : null;
              return planId ? linePlanId === String(planId) : !linePlanId;
            })[0] || null;
          }
          if (!existing) { submitNative(); return; }
          if (existing.quantity === 1) {
            /* Already exactly what a fresh add would produce: nothing to
               change, just make sure the shopper sees the drawer (this is
               what "tapped again because unsure it worked" is asking for). */
            var d0 = document.querySelector('cart-drawer');
            if (d0 && typeof d0.open === 'function') d0.open();
            else window.location.href = '/cart';
            return;
          }
          var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var body = new URLSearchParams();
          body.append('id', existing.key);
          body.append('quantity', '1');
          if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
            body.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            body.append('sections_url', window.location.pathname);
          }
          fetch(window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
            body: body.toString()
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              if (cartEl && typeof cartEl.renderContents === 'function') {
                cartEl.renderContents(response);
              } else {
                var d1 = document.querySelector('cart-drawer');
                if (d1 && typeof d1.open === 'function') d1.open();
              }
            })
            .catch(function () { submitNative(); });
        })
        .catch(function () { submitNative(); });
    }

    /* DEAD-CLICK FIX 2026-09-15 (Observer /journeys): the card dot
       (span.hrsb-card__dot) and the card head were logged as dead clicks 6
       times across 3 real mobile sessions on the PDP. The handler below DID
       fire for them, but when the tapped card was ALREADY selected nothing
       in the DOM changed, so the tap read as dead to the shopper and to the
       pixel alike. Every tap on a selectable card now gets a synchronous
       press state (apple-design: scale .96, 140ms strong ease-out, gated by
       prefers-reduced-motion), whether or not it changes the selection. */
    var HRSB_REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function hrsbPressFeedback(card) {
      if (HRSB_REDUCED) return;
      card.classList.remove('is-pressed');
      /* force a reflow so a second tap restarts the animation */
      void card.offsetWidth;
      card.classList.add('is-pressed');
      window.setTimeout(function () { card.classList.remove('is-pressed'); }, 190);
    }

    /* Card select (ignore clicks on the expandable + links) */
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (card.dataset.hrsbSoldout === 'true') return; /* sold-out card is never selectable */
        if (e.target.closest('details, a, button')) return;
        hrsbPressFeedback(card);
        state = card.dataset.hrsbCard;
        applyState(false);
      });
      card.addEventListener('keydown', function (e) {
        if (card.dataset.hrsbSoldout === 'true') return; /* sold-out card is never selectable */
        if (e.key === ' ' || e.key === 'Enter') {
          if (e.target !== card) return;
          e.preventDefault();
          state = card.dataset.hrsbCard;
          applyState(false);
        }
      });
    });

    /* Main ATC — add selected variant + plan, then open the cart drawer
       (owner directive 2026-07-25: skip_cart reverted to false in
       templates/product.json, so submitNative()'s native form submit now
       lands in the drawer instead of redirecting to /checkout). */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        runAddToCart(atcBtn);
      });
    }

    /* Member program CTA now navigates to /pages/customized-gifts (plain <a>);
       no click interception here (owner 2026-07-17). */

    /* ===== Future gifts smooth expand ===== */
    root.querySelectorAll('[data-hrsb-details]').forEach(function (details) {
      var summary = details.querySelector('summary');
      var wrap = details.querySelector('[data-hrsb-gifts-wrap]');
      if (!summary || !wrap) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = !details.classList.contains('is-open');
        if (reduceMotion) {
          details.open = willOpen;
          details.classList.toggle('is-open', willOpen);
          return;
        }
        if (willOpen) {
          /* expand: reveal content, then flip the class so the CSS
             grid-template-rows transition (0fr -> 1fr) runs from a clean start */
          details.open = true;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { details.classList.add('is-open'); });
          });
        } else {
          /* collapse: flip the class (1fr -> 0fr animates); keep the <details>
             open until the transition ends so content stays visible while it shrinks */
          details.classList.remove('is-open');
          wrap.addEventListener('transitionend', function onEnd(ev) {
            if (ev.propertyName !== 'grid-template-rows') return;
            wrap.removeEventListener('transitionend', onEnd);
            if (!details.classList.contains('is-open')) details.open = false;
          });
        }
      });
    });

    /* ===== Limited-supply track — one-shot GPU fill on scroll-into-view =====
       Server-rendered --stock-scale is already the correct resting value
       (progressive enhancement: with zero JS the bar simply sits at the right
       fill, no animation, nothing broken). When motion is allowed, JS resets
       the fill to scaleX(0) and lets the CSS transition (already declared on
       .hrsb-stock__fill, transform only, never width) carry it back up to the
       same server value exactly once, the moment the indicator scrolls into
       view. Reduced motion: skip straight to the settled state, per
       apple-design / review-animations. Guaranteed to fire via BOTH an
       IntersectionObserver and a short fallback timer, so a missed/never-firing
       IO can never leave the track stuck at empty. */
    var stockEl = root.querySelector('[data-hrsb-stock]');
    if (stockEl && !reduceMotion) {
      var stockFill = stockEl.querySelector('[data-hrsb-stock-fill]');
      var stockRan = false;
      var stockFallback = null;

      var runStockReveal = function () {
        if (stockRan || !stockFill) return;
        stockRan = true;
        if (stockFallback) { clearTimeout(stockFallback); stockFallback = null; }
        stockEl.classList.add('is-seen'); // mobile attention pop (CSS, plays once)
        var target = stockFill.style.getPropertyValue('--stock-scale');
        stockFill.style.transform = 'scaleX(0)';
        // Force a reflow so the browser registers scaleX(0) before the target
        // is reapplied, guaranteeing the CSS transition actually runs once.
        // eslint-disable-next-line no-unused-expressions
        stockFill.offsetWidth;
        requestAnimationFrame(function () {
          stockFill.style.transform = 'scaleX(' + target + ')';
        });
      };

      if ('IntersectionObserver' in window) {
        var stockIO = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { runStockReveal(); stockIO.disconnect(); break; }
          }
        }, { root: null, threshold: 0.4 });
        stockIO.observe(stockEl);
      }
      stockFallback = setTimeout(runStockReveal, 1200);
    }

    /* ===== Sticky bar — PERSISTENT, reveals at the buy cards (owner spec) =====
       The bar must NOT appear on landing (the user lands on the hero image). It
       remains hidden while the primary offer is available, then appears only
       after the main Buy Now control has scrolled above the viewport. Returning
       to the offer hides the duplicate action again.

       FIX (2026-07-18): this used to be driven by an IntersectionObserver on the
       cards. IO fires one synchronous callback immediately after observe() with
       whatever the CURRENT intersection state is — it does not wait for a real
       scroll event. At desktop widths (1280x800) `.hrsb__cards` already sits
       inside the viewport at scrollY 0, so that very first callback reported
       "intersecting" and added is-shown before the user ever scrolled. On mobile
       (390x844) the cards start below the fold, so the same first callback
       correctly reported "not intersecting" and the bug never showed there.
       Once fixed at load, IO also would not self-correct on a normal desktop
       scroll, because the cards never leave the viewport to re-trigger it.

       Replaced with a rAF-throttled scroll/resize handler that only evaluates
       actual scroll position via getBoundingClientRect, and is explicitly gated
       on window.scrollY > 8 so it can never fire at rest on initial load on any
       width. Visibility now follows the primary CTA instead of latching. */
    if (bar && !soldOut) {
      var primaryAtc = root.querySelector('[data-hrsb-atc]');
      var hrsbSetBarVisible = function (visible) {
        bar.classList.toggle('is-shown', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) bar.removeAttribute('inert');
        else bar.setAttribute('inert', '');
      };
      var hrsbBarTicking = false;
      var hrsbEvalBar = function () {
        hrsbBarTicking = false;
        if (!primaryAtc) return;
        var r = primaryAtc.getBoundingClientRect();
        hrsbSetBarVisible(r.bottom <= 0);
      };
      var hrsbOnBarScroll = function () {
        if (hrsbBarTicking) return;
        hrsbBarTicking = true;
        requestAnimationFrame(hrsbEvalBar);
      };
      window.addEventListener('scroll', hrsbOnBarScroll, { passive: true });
      window.addEventListener('resize', hrsbOnBarScroll, { passive: true });
      /* Runs once synchronously at scrollY 0 on every width — always evaluates
         to hidden (scrollY > 8 guard) instead of relying on a browser API's
         eager first-callback semantics. */
      hrsbEvalBar();

      /* BUG FIX (2026-07-26): the bar is position:fixed and reserves no layout
         space, so any section's final content can end up scrolled to rest
         directly behind it (e.g. hr-three-s's closing paragraph was clipped
         on both mobile and desktop). Publish the bar's real rendered height
         as a CSS var on :root so sections can add matching bottom clearance
         instead of guessing a fixed px number that drifts out of sync with
         the bar's own responsive/safe-area padding. */
      var hrsbSetBarHeightVar = function () {
        var h = bar.offsetHeight || 0;
        document.documentElement.style.setProperty('--hrsb-bar-h', h + 'px');
      };
      hrsbSetBarHeightVar();
      window.addEventListener('resize', hrsbSetBarHeightVar, { passive: true });
      window.addEventListener('orientationchange', function () { setTimeout(hrsbSetBarHeightVar, 50); });
      if ('ResizeObserver' in window) {
        new ResizeObserver(hrsbSetBarHeightVar).observe(bar);
      }
    }
    /* Shopify's theme-preview toolbar sits fixed at the bottom and would cover
       the sticky bar during dev review — lift it above it. */
    function hrsbPreviewBarOffset() {
      var pb = document.getElementById('preview-bar-iframe');
      var pbNext = document.getElementById('PBarNextFrame');
      if (!pb && !pbNext) return;
      /* PBarNextFrame is a full-viewport iframe whose visible strip sits at its
         bottom (~72px) — the strip height cannot be measured cross-origin. */
      var h = pb ? (pb.offsetHeight || 72) : 72;
      if (bar) bar.style.bottom = h + 'px';
      window.dispatchEvent(new Event('hrsb:reserved-bottom-change'));
    }
    setTimeout(hrsbPreviewBarOffset, 1500);
    setTimeout(hrsbPreviewBarOffset, 4000);

    /* Sticky-bar supply toggle (segmented 60-Day / 30-Day) */
    if (barSegs && barSegs.length) {
      Array.prototype.forEach.call(barSegs, function (seg) {
        seg.addEventListener('click', function () {
          state = seg.dataset.hrsbBarSeg === 'sub8once' ? 'sub8once' : 'sub8';
          applyState(false);
        });
      });
    }
    /* ===== Sticky bar: cart-state awareness (owner brief 2026-07-29) =====
      Empty cart -> the bar's action is "Add to Cart" and the 60/30 segmented toggle is
      shown (current behavior). Once anything is in the cart (cart.item_count > 0) the SAME
      bar switches to an "in cart" state: it shows the live cart summary (item count and
      total) in its price slot, hides the segmented toggle (so tapping the bar can never
      silently stack a duplicate line the shopper did not intend — supply is changed in the
      drawer instead), and its action becomes "Checkout", routing straight to checkout.

      The state is driven ENTIRELY by the real cart, read live from routes.cart_url + '.js':
        - once on init,
        - on every drawer re-render (a MutationObserver on #CartDrawer-CartItems, which
          Dawn rebuilds on every add / qty change / remove, so removing all items in the
          drawer reverts the bar to "Add to Cart"),
        - and on Dawn's cartUpdate pub/sub event when the theme exposes it.
      Currency-correct via Intl using the cart's own ISO currency (Shopify Markets safe),
      with a plain "$" fallback. */
    var HRSB_CART_URL = HRSB_CFG.cartUrl;
    var HRSB_CHECKOUT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
    var barLead = barAtc ? barAtc.querySelector('.hrsb-bar__atc-lead') : null;
    var barName = bar ? bar.querySelector('[data-hrsb-bar-name]') : null;
    var HRSB_BASE_NAME = HRSB_CFG.baseName;
    var HRSB_VARIANT60_ID = HRSB_CFG.variant60Id;
    var HRSB_VARIANT60_SUB_ID = HRSB_CFG.variant60SubId;
    var HRSB_VARIANT30_ID = HRSB_CFG.variant30Id;

    /* Owner brief 2026-07-29: once in cart, the bar's name must say which
      supply is actually in the cart (e.g. "Sea Buckthorn Puree -- 60-Day Supply"), not a
      generic static title -- so switching plans in the drawer is reflected here too. Prefer
      the real selling plan name Shopify returns on the cart line (e.g. "Delivered every 8
      weeks"); fall back to matching the line's variant id against the two known variants;
      fall back to the plain title if neither is available (e.g. empty cart). */
    function hrsbPlanLabelFromLine(line) {
      if (!line) return '';
      /* Prefer OUR "60-Day"/"30-Day" wording (matches the toggle + buy box copy
         everywhere else on the page) over Shopify's raw selling-plan name, which
         reads verbose/inconsistent (e.g. "2-Month Supply - every 8 weeks"). Only
         fall back to the raw plan name if the line's variant matches neither
         known variant (e.g. a future/unexpected plan). */
      if (HRSB_VARIANT60_ID && line.variant_id === HRSB_VARIANT60_ID) return '60-Day Supply';
      if (HRSB_VARIANT60_SUB_ID && line.variant_id === HRSB_VARIANT60_SUB_ID) return '60-Day Supply';
      if (HRSB_VARIANT30_ID && line.variant_id === HRSB_VARIANT30_ID) return '30-Day Supply';
      var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      return (plan && plan.name) || '';
    }

    function hrsbFormatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
      } catch (e) {
        return '$' + ((cents || 0) / 100).toFixed(2);
      }
    }

    /* Owner directive 2026-08-22: mobile sticky bar was ~110-130px tall (thumb +
       2-line name + price + segmented toggle + chip row all stacked). On phones
       it must be a single compact row, so below 990px the name always reads the
       short "60-Day Supply" label instead of the full product title (the CSS
       companion hides the segmented toggle + chip row at the same breakpoint —
       see .hrsb-bar mobile block in hr-subscription-box.css). Desktop keeps the
       full title untouched. */
    var HRSB_MOBILE_BAR_MQ = window.matchMedia('(max-width: 989px)');

    function hrsbRenderCartState(count, totalCents, currency, planLabel) {
      if (!bar) return;
      var inCart = count > 0;
      var isMobileBar = HRSB_MOBILE_BAR_MQ.matches;
      bar.classList.toggle('is-incart', inCart);
      if (inCart) {
        if (barSegWrap) barSegWrap.style.display = 'none';
        if (barPrice) barPrice.textContent = count + (count === 1 ? ' item' : ' items') + ' · ' + hrsbFormatMoney(totalCents, currency);
        if (barName) barName.textContent = isMobileBar ? (planLabel || '60-Day Supply') : (planLabel ? (HRSB_BASE_NAME + ' — ' + planLabel) : HRSB_BASE_NAME);
        if (barLead) barLead.textContent = 'Checkout';
        if (barAtc) { barAtc.disabled = false; barAtc.setAttribute('aria-label', 'Checkout'); }
      } else {
        if (barSegWrap) barSegWrap.style.display = '';
        applyState(false); /* restores per-plan price, selection visuals and disabled state */
        if (barName) barName.textContent = isMobileBar ? '60-Day Supply' : HRSB_BASE_NAME;
        if (barLead) barLead.textContent = 'Add to Cart';
        if (barAtc) barAtc.setAttribute('aria-label', 'Add to cart');
      }
    }

    function hrsbRefreshCartState() {
      if (!bar) return;
      fetch(HRSB_CART_URL + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          /* Prefer the line matching this product's two known variants (in case the cart
             holds other products too); fall back to the first line so the bar still updates. */
          var line = null;
          if (Array.isArray(c.items)) {
            line = c.items.filter(function (it) {
              return it.variant_id === HRSB_VARIANT60_ID || it.variant_id === HRSB_VARIANT60_SUB_ID || it.variant_id === HRSB_VARIANT30_ID;
            })[0] || c.items[0];
          }
          hrsbRenderCartState(c.item_count, c.total_price, c.currency, hrsbPlanLabelFromLine(line));
        })
        .catch(function () {});
    }
    var hrsbRefreshT = null;
    function hrsbRefreshCartStateDebounced() {
      clearTimeout(hrsbRefreshT);
      hrsbRefreshT = setTimeout(hrsbRefreshCartState, 120);
    }

    if (barAtc) {
      barAtc.addEventListener('click', function () {
        if (bar && bar.classList.contains('is-incart')) {
          window.location.href = HRSB_CHECKOUT_URL;
          return;
        }
        runAddToCart(barAtc);
        /* The native add opens the drawer and re-renders it; the observer below then
           flips the bar to its in-cart state. This extra poll covers the rare case
           where the drawer markup is absent. */
        setTimeout(hrsbRefreshCartState, 600);
      });
    }

    if (bar) {
      hrsbRefreshCartState();
      /* Observe the STABLE drawer container. Dawn's renderContents replaces the
         innerHTML of #CartDrawer on every add / qty change / remove, so #CartDrawer
         itself persists while #CartDrawer-CartItems inside it is swapped out. An
         observer bound to the inner node would stop firing after the first re-render
         (its node is detached); binding to #CartDrawer catches every cart change from
         any source, including removals done inside the drawer (reverts the bar). */
      var hrsbDrawerEl = document.getElementById('CartDrawer');
      if (hrsbDrawerEl && 'MutationObserver' in window) {
        new MutationObserver(hrsbRefreshCartStateDebounced).observe(hrsbDrawerEl, { childList: true, subtree: true });
      }
      /* Dawn publishes cart changes through a GLOBAL pub/sub (subscribe / PUB_SUB_EVENTS
         live in global.js scope, not on window). typeof guards so referencing an
         undefined global can never throw. */
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, hrsbRefreshCartStateDebounced);
        }
      } catch (e) {}
      /* Belt-and-suspenders: the drawer dispatches these on the document. */
      document.addEventListener('cart:open', hrsbRefreshCartStateDebounced);
      document.addEventListener('cart:refresh', hrsbRefreshCartStateDebounced);
      /* Refresh when the page is restored from bfcache (back button). */
      window.addEventListener('pageshow', function (e) { if (e.persisted) hrsbRefreshCartState(); });
      /* Re-render the bar name when crossing the 989px compact-bar breakpoint
         (rotation, resize, devtools) so the "60-Day Supply" short label swaps
         back to the full title correctly instead of sticking to whichever
         state was true on first paint. */
      if (HRSB_MOBILE_BAR_MQ.addEventListener) {
        HRSB_MOBILE_BAR_MQ.addEventListener('change', hrsbRefreshCartState);
      }
    }

    /* ===== Benefit detail disclosure =====
       Each row is a <button>; clicking it clones that row's <template> detail (what it
       does / why it matters / food comparison) into one shared surface. It is a modal
       bottom sheet on mobile and a non-blocking, source-anchored popover on desktop.
       Closes on X, mobile scrim tap, or Esc; focus returns to the
       row that opened it. The <template> content is supplementary, so if JS never runs
       the rows simply stay non-interactive with their label + sub visible (fail-safe). */
    (function () {
      var feelModal = root.querySelector('[data-hrsb-feel-modal]');
      if (!feelModal) return;
      /* Guard against double-init (Shopify section re-render / duplicate script
         execution). Without this, a second run attaches a second, independent set
         of open/close listeners to the SAME shared modal node; each instance has
         its own feelCloseTimer/feelCloseOnEnd/feelReturn, so after any close BOTH
         instances race to finish teardown and the modal is left in a state only
         one of the two closures still thinks is "open" -> every open after that
         either no-ops or gets silently undone by the other instance. This is the
         root cause of the "popup goes dead after the first close" bug. */
      if (feelModal.__hrsbFeelInit) return;
      feelModal.__hrsbFeelInit = true;
      var feelInline = root.querySelector('[data-hrsb-feel-inline]');
      var feelInlineBody = feelInline ? feelInline.querySelector('[data-hrsb-feel-inline-body]') : null;
      /* Fixed overlay must not sit under a transformed ancestor. */
      if (feelModal.parentNode !== document.body) document.body.appendChild(feelModal);
      var feelBody = feelModal.querySelector('[data-hrsb-feel-body]');
      var feelCard = feelModal.querySelector('.hrsb-feel-modal__card');
      var feelX = feelModal.querySelector('.hrsb-feel-modal__x');
      var feelReturn = null;
      var feelRows = Array.prototype.slice.call(root.querySelectorAll('[data-hrsb-feel-row]'));
      /* Pending-close handles. A close animates out over ~320ms and only then flips
         feelModal.hidden = true and unlocks scroll. If the user reopens a DIFFERENT row
         inside that window, the stale close callback used to fire AFTER the reopen and
         hide the just-opened popup (owner bug: "card either shows up or shows the wrong
         one"). We now cancel any pending close before every open. */
      var feelCloseTimer = null;
      var feelCloseOnEnd = null;
      var feelScrollY = 0;
      var feelDidLock = false;
      /* Monotonic token. Every open OR close bumps it and captures its own value;
         any deferred callback (transitionend / setTimeout) checks its captured
         value against the live one before touching state, so a stale callback
         from an interrupted close/open can never clobber whatever is current. */
      var feelGen = 0;
      var feelBodyStyle = { top: document.body.style.top, position: document.body.style.position, width: document.body.style.width };

      function feelIsSheet() {
        return true;
      }

      function feelSetPreviewReserve() {
        var previewBar = document.getElementById('preview-bar-iframe');
        var previewNext = document.getElementById('PBarNextFrame');
        var reserve = 0;
        if (previewBar) {
          var previewRect = previewBar.getBoundingClientRect();
          if (previewRect.height > 0 && previewRect.height < window.innerHeight / 2) {
            reserve = Math.ceil(previewRect.height);
          }
        } else if (previewNext) {
          /* PBarNextFrame is a full-height cross-origin frame, but its visible
             Shopify preview strip occupies the final 72px. */
          reserve = 72;
        }
        feelModal.style.setProperty('--hrsb-preview-reserve', reserve + 'px');
      }

      function feelSetRowState(activeRow) {
        feelRows.forEach(function (rowBtn) {
          var isActive = rowBtn === activeRow;
          rowBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          rowBtn.classList.toggle('is-active', isActive);
          if (isActive) rowBtn.setAttribute('aria-current', 'true');
          else rowBtn.removeAttribute('aria-current');
        });
      }

      function feelLockScroll() {
        if (!feelIsSheet()) return;
        if (document.body.classList.contains('hrsb-feel-lock')) return;
        feelScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        feelDidLock = true;
        document.documentElement.classList.add('hrsb-feel-lock');
        document.body.classList.add('hrsb-feel-lock');
        document.body.style.top = '-' + feelScrollY + 'px';
      }

      function feelUnlockScroll() {
        if (!feelDidLock) return;
        document.documentElement.classList.remove('hrsb-feel-lock');
        document.body.classList.remove('hrsb-feel-lock');
        document.body.style.top = feelBodyStyle.top;
        document.body.style.position = feelBodyStyle.position;
        document.body.style.width = feelBodyStyle.width;
        window.scrollTo(0, feelScrollY);
        feelDidLock = false;
      }

      function feelFocusable() {
        if (!feelCard) return [];
        return Array.prototype.slice.call(feelCard.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      }

      function feelDesktopBottomBoundary(viewportHeight) {
        var edgeGap = 16;
        var surfaceGap = 12;
        var boundary = viewportHeight - edgeGap;
        var previewBar = document.getElementById('preview-bar-iframe');
        var previewNext = document.getElementById('PBarNextFrame');

        /* The classic preview iframe exposes its strip height; PBarNextFrame is
           full-viewport and only exposes a roughly 72px visible footer. */
        if (previewBar || previewNext) {
          var previewHeight = 72;
          if (previewBar) {
            var previewRect = previewBar.getBoundingClientRect();
            if (previewRect.height > 0 && previewRect.height < viewportHeight / 2) {
              previewHeight = previewRect.height;
            }
          }
          boundary = Math.min(boundary, viewportHeight - previewHeight - surfaceGap);
        }

        if (bar && bar.classList.contains('is-shown')) {
          /* Use the bar's final fixed position, not its transformed rect while it
             is sliding in. This keeps the popover clear throughout that motion. */
          var bottomOffset = parseFloat(window.getComputedStyle(bar).bottom) || 0;
          var barTop = viewportHeight - bottomOffset - bar.offsetHeight;
          boundary = Math.min(boundary, barTop - surfaceGap);
        }

        return Math.max(176, boundary);
      }

      function feelPosition(rowBtn) {
        if (!feelCard) return;
        if (feelIsSheet()) {
          feelCard.style.removeProperty('left');
          feelCard.style.removeProperty('top');
          feelCard.style.removeProperty('width');
          feelCard.style.removeProperty('max-height');
          feelCard.style.removeProperty('transform-origin');
          return;
        }

        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = document.documentElement.clientHeight;
        var viewportTop = 16;
        var usableBottom = feelDesktopBottomBoundary(viewportHeight);
        var availableHeight = Math.max(160, usableBottom - viewportTop);
        var cardWidth = Math.min(440, viewportWidth - 32);
        var rowRect = rowBtn.getBoundingClientRect();
        var left = rowRect.left - cardWidth - 16;
        var originX = '100%';

        if (left < 16) {
          left = rowRect.right + 16;
          originX = '0%';
        }
        if (left + cardWidth > viewportWidth - 16) {
          left = Math.max(16, (viewportWidth - cardWidth) / 2);
          originX = '50%';
        }

        feelCard.style.width = Math.round(cardWidth) + 'px';
        feelCard.style.left = Math.round(left) + 'px';
        feelCard.style.top = viewportTop + 'px';
        feelCard.style.maxHeight = Math.floor(availableHeight) + 'px';

        var cardHeight = feelCard.offsetHeight;
        var top = Math.max(viewportTop, Math.min(rowRect.top, usableBottom - cardHeight));
        var originY = Math.max(24, Math.min(cardHeight - 24, rowRect.top + (rowRect.height / 2) - top));
        feelCard.style.top = Math.round(top) + 'px';
        feelCard.style.transformOrigin = originX + ' ' + Math.round(originY) + 'px';
      }

      function feelCancelPendingClose() {
        if (feelCloseTimer) { clearTimeout(feelCloseTimer); feelCloseTimer = null; }
        if (feelCloseOnEnd) { feelCard.removeEventListener('transitionend', feelCloseOnEnd); feelCloseOnEnd = null; }
      }

      function feelOpen(rowBtn) {
        var tpl = rowBtn.querySelector('[data-hrsb-feel-detail]');
        if (!tpl || !feelBody) return;
        /* Kill any in-flight close so it can't hide this freshly opened popup. */
        feelCancelPendingClose();
        feelGen += 1;
        feelModal.style.pointerEvents = '';
        if (false && !feelIsSheet() && feelInline && feelInlineBody) {
          if (feelReturn === rowBtn && !feelInline.hidden) {
            feelInline.classList.remove('is-open');
            feelInline.hidden = true;
            feelSetRowState(null);
            feelReturn = null;
            return;
          }
          while (feelInlineBody.firstChild) feelInlineBody.removeChild(feelInlineBody.firstChild);
          feelInlineBody.appendChild(tpl.content ? tpl.content.cloneNode(true) : tpl.cloneNode(true));
          feelReturn = rowBtn;
          feelSetRowState(rowBtn);
          feelInline.hidden = false;
          if (!reduceMotion) void feelInline.offsetWidth;
          feelInline.classList.add('is-open');
          feelInline.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
          return;
        }
        var feelSymbol = rowBtn.querySelector('.hrsb-feel__symbol');
        feelCard.setAttribute('data-symbol', feelSymbol ? feelSymbol.textContent.replace(/\s+/g, ' ').trim() : '');
        while (feelBody.firstChild) feelBody.removeChild(feelBody.firstChild);
        feelBody.appendChild(tpl.content ? tpl.content.cloneNode(true) : tpl.cloneNode(true));
        var titleEl = feelBody.querySelector('.hrsb-fm__title');
        if (titleEl) {
          if (!titleEl.id) titleEl.id = 'hrsb-fm-title-' + HRSB_CFG.sectionId;
          feelCard.setAttribute('aria-labelledby', titleEl.id);
        }
        feelReturn = rowBtn;
        feelModal.hidden = false;
        feelSetPreviewReserve();
        if (feelIsSheet()) feelCard.setAttribute('aria-modal', 'true');
        else feelCard.removeAttribute('aria-modal');
        feelSetRowState(rowBtn);
        feelLockScroll();
        feelPosition(rowBtn);
        /* Flush the pre-open state synchronously (a forced reflow), then add is-open in
           the same task so the CSS transition runs. This does NOT depend on rAF firing
           (background/throttled tabs never leave the sheet stuck at opacity:0 / offscreen,
           the way a missed double-rAF would). */
        if (!reduceMotion) { void feelCard.offsetWidth; }
        feelModal.classList.add('is-open');
        if (feelX) feelX.focus();
      }

      function feelClose() {
        if (feelInline && !feelInline.hidden) {
          feelInline.classList.remove('is-open');
          feelInline.hidden = true;
          feelSetRowState(null);
          if (feelReturn && feelReturn.focus) feelReturn.focus();
          feelReturn = null;
          return;
        }
        if (feelModal.hidden) return;
        feelCancelPendingClose();
        feelGen += 1;
        var myGen = feelGen;
        feelModal.classList.remove('is-open');
        feelSetRowState(null);
        /* Make the (now invisible-but-still-fixed-and-full-viewport) overlay
           pointer-inert immediately, so a tap during the ~320ms teardown window
           can never be swallowed by the fading scrim/card instead of reaching
           whatever the user actually meant to hit (including a different row). */
        feelModal.style.pointerEvents = 'none';
        var finish = function () {
          if (myGen !== feelGen) return; /* superseded by a newer open/close */
          feelCloseTimer = null;
          feelCloseOnEnd = null;
          feelModal.hidden = true;
          feelModal.style.pointerEvents = '';
          feelUnlockScroll();
          feelCard.removeAttribute('aria-modal');
          if (feelReturn && feelReturn.focus) feelReturn.focus();
          feelReturn = null;
        };
        if (reduceMotion) { finish(); return; }
        feelCloseOnEnd = function (ev) {
          if (ev.target !== feelCard) return;
          feelCard.removeEventListener('transitionend', feelCloseOnEnd);
          feelCloseOnEnd = null;
          if (feelCloseTimer) { clearTimeout(feelCloseTimer); feelCloseTimer = null; }
          finish();
        };
        feelCard.addEventListener('transitionend', feelCloseOnEnd);
        feelCloseTimer = setTimeout(function () {
          feelCloseTimer = null;
          if (feelCloseOnEnd) { feelCard.removeEventListener('transitionend', feelCloseOnEnd); feelCloseOnEnd = null; }
          finish();
        }, 320);
      }

      feelRows.forEach(function (rowBtn) {
        rowBtn.addEventListener('click', function () { feelOpen(rowBtn); });
      });
      feelModal.querySelectorAll('[data-hrsb-feel-close]').forEach(function (el) {
        el.addEventListener('click', feelClose);
      });
      if (feelInline) {
        feelInline.querySelectorAll('[data-hrsb-feel-inline-close]').forEach(function (el) {
          el.addEventListener('click', feelClose);
        });
      }
      document.addEventListener('keydown', function (e) {
        if (feelModal.hidden && (!feelInline || feelInline.hidden)) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          feelClose();
          return;
        }
        if (e.key !== 'Tab' || !feelIsSheet()) return;
        var focusable = feelFocusable();
        if (!focusable.length) {
          e.preventDefault();
          feelCard.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
      window.addEventListener('resize', function () {
        if (feelInline && !feelInline.hidden && feelIsSheet()) feelClose();
        if (!feelModal.hidden && feelReturn) {
          feelSetPreviewReserve();
          feelPosition(feelReturn);
        }
      });
      var feelPositionTicking = false;
      window.addEventListener('scroll', function () {
        if (feelModal.hidden || !feelReturn || feelIsSheet() || feelPositionTicking) return;
        feelPositionTicking = true;
        requestAnimationFrame(function () {
          feelPositionTicking = false;
          if (!feelModal.hidden && feelReturn) feelPosition(feelReturn);
        });
      }, { passive: true });
      window.addEventListener('orientationchange', function () {
        window.setTimeout(function () { if (!feelModal.hidden && feelReturn) feelPosition(feelReturn); }, 0);
      });
      window.addEventListener('hrsb:reserved-bottom-change', function () {
        if (!feelModal.hidden && feelReturn && !feelIsSheet()) feelPosition(feelReturn);
      });
      if (bar) {
        bar.addEventListener('transitionend', function (e) {
          if (e.propertyName === 'transform' && !feelModal.hidden && feelReturn && !feelIsSheet()) {
            feelPosition(feelReturn);
          }
        });
      }
    })();

    applyState(true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hrsbInit);
    } else {
      hrsbInit();
    }
  })();
